import { responsiveFontSizes } from '@material-ui/core';
import { createTheme } from '@material-ui/core/styles';

// Single source of truth for the Material-UI theme, shared by the runtime
// entry point (src/index.jsx) and the test render wrapper (src/test-utils.jsx).
let theme = createTheme({
  typography: {
    fontFamily: 'Roboto, Helvetica, Arial, sans-serif',
    h1: {
      color: '#202124',
      fontSize: '26px',
      fontWeight: 500,
    },
    h2: {
      color: '#202124',
      fontSize: '18px',
      fontWeight: 500,
      lineHeight: 1.25,
    },
    subtitle1: {
      color: '#7B7D82',
      fontSize: '13px',
      lineHeight: '20px',
    },
    subtitle2: {
      color: '#202124',
      fontSize: '13px',
    },
  },
});
theme = responsiveFontSizes(theme);

export default theme;
